import React from 'react';
import Card from './custom-style-componets';
import BG_CARD from './../../images/card.svg';

export const ListSkeleton = () => {
  const fakeArray = Array.from({ length: 5 }, (v, i) => i);
  return (
    fakeArray.map(() => <div className="card"><Card><img src={BG_CARD} alt='source' /></Card></div>)
  );
};


